import React from 'react'

const UserAccountBeneficiary = (props)=> {
  return (
    <div className='form-item-value'>
        <ul>

            <li className='flex'>
                <div className="flex-1 placeholder">Beneficiary Name</div>
                <span className="btn-icon" onClick={props.onAdd}><img className="icon-small" src="img/icon/plus_black.svg" alt="icon pretrade"/></span>
            </li>

        {
            props.beneficiaries.map((item,idx)=>(
                <li key={idx} className="flex">
                    <input className='flex-1' type="text" value={item} onChange={e=>props.onChange(e,idx)}/>
                    <span className="btn-icon" onClick={p=>props.onRemove(idx)}><img className="icon-small" src="img/icon/delete.svg" alt="icon pretrade"/></span>
                </li>
            ))
        }
        </ul>
    </div>
  )
}

export default UserAccountBeneficiary;